import { render, staticRenderFns } from "./SpouseTransfer.vue?vue&type=template&id=77b263e8&scoped=true&"
import script from "./SpouseTransfer.vue?vue&type=script&lang=js&"
export * from "./SpouseTransfer.vue?vue&type=script&lang=js&"
import style0 from "./SpouseTransfer.vue?vue&type=style&index=0&id=77b263e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b263e8",
  null
  
)

export default component.exports